import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UnauthGuardService implements CanActivate {
  constructor(private auth: AuthService, private router: Router) { }

  canActivate(): boolean {
    const isLoggedIn = this.auth.isLoggedIn();
    if (isLoggedIn) {
      this.router.navigate(['/admin']);
      return false;
    } else {
      return true;
    }
  }
}
